import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class TripRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }

  async getTripsByIdRoute(idRoute) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/route/${idRoute}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data.trips;
    } catch (e) {
      return [];
    }
  }

  async getTrips(page, rowsPerPage) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/trip?pageNum=${page}&pageSize=${rowsPerPage}`;

    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response;
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
}

Container.set({ id: TripRepository, type: TripRepository });

export default TripRepository;
